// extracted by mini-css-extract-plugin
export default {"ctaContainer":"G5029f0"};